import styled from 'styled-components';
import { colors, breakpoints } from 'app/variables';

export const PrivacyWrapper = styled.div`
  display: block;
  flex-shrink: 0;
  padding: 1.5rem 0.5rem;
  font-size: 0.9rem;
  line-height: 1.5;
  text-align: center;

  @media (min-width: ${breakpoints.mediumDesktop}) {
    padding: 2rem 0;
  }
`;

export const PrivacyLink = styled.a`
  color: inherit;
  text-decoration: none;

  &:hover {
    color: ${colors.pacificBlue};
  }
`;
